module.exports = __webpack_public_path__ + "img/94.418e50a3.jpg";